import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHeartBroken } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'app-internal-server-error',
  imports: [FontAwesomeModule, ButtonModule, RouterModule],
  templateUrl: './internal-server-error.component.html',
  styleUrl: './internal-server-error.component.scss'
})
export class InternalServerErrorComponent {
  faHeartBroken = faHeartBroken;
}
